<template>
  <div class="space-info-container">
    <div class="parent-avatar">
      <div :style="borderStyle" class="hexagon-avt">
        <img :src="avatarURL" class="hexagon-avt avatar child-img-1" />
      </div>
      <img src="../../assets/share/verified.svg" class="child-img-2" v-if="isVerified && !isImported"/>
    </div>
    <div class="space-and-interest-titles-container">
      <div class="space-title-container">
        <p>
            {{ spaceTitle }}<img src="../../assets/share/imported.svg" class="imported-space-img" v-if="isImported"/>
        </p>
      </div>
      <div class="interest-title-container">
        <p>@{{ interest }}</p>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "SpaceInfo",
  data(){
    return {
      maxCharsToShow: 35,
    }
  },
  props: {
    avatarURL: {
      type: String,
      required: true,
    },
    avatarColor: {
      type: String,
    },

    spaceTitle: {
      type: String,
    },
    interest: {
      type: String,
    },
    isVerified: {
      type: Boolean,
    },
    isImported: {
      type: Boolean,
    },

  },
  computed: {
    borderStyle() {
      return {
        backgroundColor: this.avatarColor,
        width: "48.1px",
        height: "42.4px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      };
    },
  },
};
</script>


<style scoped>
/* Avatar  */
.parent-avatar{
  position: relative;
}
.child-img-1{
  position: absolute;
}
.child-img-2{
  position: absolute;
  top: 31%;
  left: 74%;
  width: 1rem;
  height: 1rem;
}
.hexagon-avt {
  -webkit-clip-path: polygon(25% 0, 75% 0, 100% 50%, 75% 100%, 25% 100%, 0 50%);
  clip-path: polygon(25% 0, 75% 0, 100% 50%, 75% 100%, 25% 100%, 0 50%);
}
.avatar {
  object-fit: cover;
  width: 46.1px;
  height: 39.9px;
}

/* Texts containers  */
.space-title-container {
  font-stretch: normal;
  font-style: normal;
  text-align: left;
  letter-spacing: normal;
  color: #fff;
  font-weight: 500;
  font-size: 1.0rem;
  width: 100%;
}

.interest-title-container {
  font-size: 0.65rem;
  font-weight: 100;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  color: #fff;
}

.space-and-interest-titles-container {
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
  width: 100%;
}

/* Text */
.space-and-interest-titles-container p {
    display:flex;
    flex-direction: row;
    margin: 0;
    padding: 0;
    line-height: 1.25rem;
    word-break: break-word;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 78%;
}

/* Flex  */
.space-info-container {
  z-index: 100;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
}
.imported-space-img{
  margin-left: 0.3rem;
}

</style>